/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bot_Does_3Inputs */

const en_bot_does_3 = /** @type {(inputs: Bot_Does_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Honours robots.txt (RFC 9309) for every page, the first one included. Crawl-delay is honoured up to 5 seconds; when robots.txt errors or cannot be reached, BystepBot reads nothing.`)
};

const id_bot_does_3 = /** @type {(inputs: Bot_Does_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mematuhi robots.txt (RFC 9309) untuk setiap halaman, termasuk halaman pertama. Crawl-delay dihormati sampai 5 detik; bila robots.txt error atau tidak terjangkau, BystepBot tidak membaca apa pun.`)
};

/**
* | output |
* | --- |
* | "Honours robots.txt (RFC 9309) for every page, the first one included. Crawl-delay is honoured up to 5 seconds; when robots.txt errors or cannot be reached, B..." |
*
* @param {Bot_Does_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_does_3 = /** @type {((inputs?: Bot_Does_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Does_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_does_3(inputs)
	return en_bot_does_3(inputs)
});